<template>
  <Teleport to="body">
    <div v-if="show" class="modal-overlay" @mousedown.self="close">
      <dialog class="card modal-content">
        <div class="modal-header">
          <h3 class="modal-title">Параметры предпросмотра</h3>
          <button class="close-btn" type="button" @click="close">
            ✕
          </button>
        </div>

        <div class="form-body custom-scroll">
          <p class="helper-text">
            Выберите объект, данными которого будет заполнен шаблон.
          </p>

          <div
            v-if="!isKindLocked && !isCargoKind"
            class="form-group"
          >
            <base-label for="type" :required="true">
              Тип объекта
            </base-label>
            <BaseSelect
              id="type"
              v-model="form.record_type"
              :options="typeOptions"
              placeholder="Выберите тип"
              :clearable="false"
            />
          </div>

          <!-- Обычный режим (order / order_invoice) -->
          <template v-if="!isCargoKind">
            <div class="form-group">
              <base-label for="order" :required="true">
                Объект
              </base-label>
              <order-select
                id="order"
                v-model="form.order_id"
                placeholder="Выберите заказ"
                :auto-select-first="true"
              />
            </div>

            <div v-if="isKindLocked" class="form-group">
              <base-label :required="true">Счёт</base-label>
              <invoice-select
                v-model="form.record_id"
                :order-id="form.order_id"
                placeholder="Выберите счёт"
                :clearable="false"
                :auto-select-first="true"
              />
            </div>
          </template>

          <!-- Режим груза (cargo) -->
          <template v-if="isCargoKind">
            <div class="form-group">
              <base-label for="trip" :required="true">
                Объект
              </base-label>
              <trip-select
                id="trip"
                v-model="form.trip_id"
                placeholder="Выберите рейс"
                :clearable="false"
                :auto-select-first="true"
              />
            </div>

            <div class="form-group">
              <base-label :required="true">Груз</base-label>
              <cargo-select
                v-model="form.record_id"
                :trip-id="form.trip_id"
                placeholder="Выберите груз"
                :clearable="false"
                :auto-select-first="true"
              />
            </div>
          </template>
        </div>

        <div class="form-actions sticky-footer">
          <base-primary-button
            @click="handleRender"
            :disabled="!isValid"
            :loading="isLoading"
          >
            Сгенерировать PDF
          </base-primary-button>
          <base-button @click="close">Отмена</base-button>
        </div>
      </dialog>
    </div>
  </Teleport>
</template>

<script>
import OrderSelect from "@/components/Order/OrderSelect.vue";
import InvoiceSelect from "@/components/Invoice/InvoiceSelect.vue";
import TripSelect from "@/components/Trip/TripSelect.vue";
import CargoSelect from "@/components/Cargo/CargoSelect.vue";

export default {
  name: "TemplatePreviewModal",

  components: { OrderSelect, InvoiceSelect, TripSelect, CargoSelect },

  props: {
    show: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    kind: { type: String, default: null },
  },

  emits: ["close", "submit"],

  data() {
    return {
      form: {
        record_type: "Order",
        order_id: "",
        trip_id: "",
        record_id: "",
      },
      typeOptions: [{ value: "Order", label: "Заказ" }],
    };
  },

  computed: {
    isKindLocked() {
      return this.kind === "order_invoice";
    },

    isCargoKind() {
      return this.kind === "expeditor_sheet";
    },

    isValid() {
      if (this.isCargoKind) {
        return !!(this.form.trip_id && this.form.record_id);
      }
      if (this.isKindLocked) {
        return !!(this.form.order_id && this.form.record_id);
      }
      return !!(this.form.record_type && this.form.order_id);
    },
  },

  watch: {
    show(val) {
      if (val) {
        this.form.order_id = "";
        this.form.trip_id = "";
        this.form.record_id = "";
        this.form.record_type = "Order";
      }
    },

    "form.order_id"() {
      if (!this.isCargoKind) {
        this.form.record_id = "";
      }
    },

    "form.trip_id"() {
      if (this.isCargoKind) {
        this.form.record_id = "";
      }
    },
  },

  methods: {
    close() {
      this.$emit("close");
    },

    handleRender() {
      if (!this.isValid) return;

      if (this.isCargoKind) {
        this.$emit("submit", {
          record_type: "Cargo",
          record_id: this.form.record_id,
        });
        return;
      }

      this.$emit("submit", {
        record_type: this.isKindLocked
          ? "Order::Invoice"
          : this.form.record_type,
        record_id: this.isKindLocked
          ? this.form.record_id
          : this.form.order_id,
      });
    },
  },
};
</script>

<style scoped>
.modal-content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
}

.modal-header {
  padding: 20px;
  border-bottom: 1px solid var(--color-grey);
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  flex-shrink: 0;
}

.modal-title {
  margin: 0;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.close-btn:hover {
  color: var(--color-dark);
  background: #f5f5f5;
}

.form-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.custom-scroll::-webkit-scrollbar {
  width: 6px;
}

.custom-scroll::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 3px;
}

.custom-scroll::-webkit-scrollbar-thumb:hover {
  background: #bbb;
}

.helper-text {
  font-size: 14px;
  color: #666;
  margin-bottom: var(--base-in-indent);
  line-height: 1.4;
}

.sticky-footer {
  padding: 20px;
  border-top: 1px solid var(--color-grey);
  background: #fff;
  display: flex;
  align-items: center;
  gap: 15px;
  flex-shrink: 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

@media screen and (max-width: 767px) {
  .sticky-footer {
    gap: 10px;
  }

  .sticky-footer button {
    flex: 1;
  }
}
</style>
